export default "__VITE_ASSET__orzh3jzG__"